export default __webpack_public_path__ + "static/media/avatar-6.8d6c5c60.png";